
<template>
  <span>
    <div
      class="background-wallpaper"
      style="
        background-image: url('https://res.cloudinary.com/hyimvofxm/image/upload/v1636737932/9_68caa27a4e.png');
      "
    ></div>
    <img
      src="https://res.cloudinary.com/hyimvofxm/image/upload/v1653867967/Muirakitan_REMIX_1500px_ee0f0a097e.jpg"
      style="width: 500px; max-width: 80%; text-align: Center"
    />
    <FormulateForm class="spaced contactform n" @submit="submitForm">
      <div class="container content">
        <div class="column c12 text-center">
          <h2>CONTEST</h2>
        </div>
        <div class="column c8 push-center" style="padding: 20px">
          <p class="text-center">
            MUIRAKITAN REMIX CONTEST IS NOW CLOSED <br />
            <b>If you have already registered, you will recieve an email showing you how to submit your work</b>
          </p>
          <div style="min-height:40vh">--</div>
          <!-- <p class="text-center">
            We are happy to announce that Muirakitan's legendary title track of
            his EP is now available for YOU to remix!
          </p>
          <p class="text-center">
            We will carefully listen to all the tracks and in the end choose 4
            of them which will be released as an EP on Patronus Records.
          </p>
          <p class="text-center">
            Get your wands and potion ingredients ready and start brewing! We
            are looking forward to hear all of your creations!
          </p>

          <h2>How to participate:</h2>
          <p class="text-center">
            1. Register your email address to enter the contest.<br />
            2. YYou will receive a download link on your email with all the
            stems of Muirakitan's original project and further instructions.
            <br />
            3. Revisit this page when you're done and share the
            <b>private</b> link to your work! (use the copy link function and
            double check the link to make sure it works! - we will not notify
            you if the link is not working)
          </p>
          <h2>Contest Rules:</h2>
          <p class="text-center">
            <b>DEADLINE:</b> 31 August 2022 <br />
            The submitted track <b>MUST</b> be private<br />
            Do <b>NOT</b> share the track publicly until the end of the
            competition. This will automatically forfeit you form the contest
          </p>
          <div class="form">
            <div class="form-item form-section">
              <div class="label">Full name</div>
              <FormulateInput
                type="text"
                name="fullname"
                validation="required"
                class="form-100"
                v-model="form.Fullname"
              />
            </div>
            <div class="form-item form-section">
              <div class="label">Email address</div>
              <FormulateInput
                type="email"
                name="Email"
                validation="required"
                class="form-100"
                v-model="form.Email"
              />
            </div>
            <div class="form-item form-section">
              <div class="label">Artist Name</div>
              <FormulateInput
                type="text"
                name="Artist"
                id="Artist"
                validation="required"
                class="form-100"
                v-model="form.Artist"
              />
            </div>
          </div>
          <div class="form-item form-section">
            <div class="label">Share a small Bio</div>
            <FormulateInput
              type="textarea"
              name="Message"
              validation="required"
              class="form-100"
              v-model="form.Message"
            />
          </div>
          <div class="form-item subbutton">
            <input class="submit" type="submit" :disabled="isDisabled" />
          </div> -->
        </div>
      </div>
    </FormulateForm>
  </span>
</template>
<script>
import emailjs from 'emailjs-com'

export default {
  title: 'Patronus Records - Contest',
  name: 'home',
  data () {
    return {
      isDisabled: false,
      form: {
        Fullname: '',
        Email: '',
        Artist: '',
        Message: ''
      },
      body: null
    }
  },
  methods: {
    submitForm () {
      this.isDisabled = true
      console.log(this.form)
      emailjs
        .send(
          'service_omqin1f',
          'template_wfz0gdk',
          {
            from_name: this.form.Fullname,
            from_email: this.form.Email,
            to_email: this.form.Email,
            Artist: this.form.Artist,
            Tag: 'Competition',
            type: 'Contact',
            message: this.form.Message
          },
          'user_rDkovUZ6FIPW5500KTKAa'
        )
        .then(
          (result) => {
            console.log('SUCCESS!', result)
            this.$router.push('thankyou')
          },
          (error) => {
            console.log('FAILED...', error)
            this.isDisabled = false
          }
        )
    }
  }
}
</script>

<style>
.banner {
  width: 100vw;
  /* height: 420px; */
  padding-bottom: 500px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow: hidden;
  background-position: top center;
  background-size: cover;
}
.subscribe-box {
  max-width: 800px;
  width: 80%;
  padding: 40px;
  margin: 30px auto;
}
.subbutton {
  border: 0px;
  width: 100%;
  display: block;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 800;
  background-color: var(--secondary);
}
a.subbutton-2 {
  width: 100%;
  display: block;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 800;
  background-color: red;
  opacity: 0.8;
}
.contactform .banner {
  width: 100vw;
  /* height: 420px; */
  padding-bottom: 500px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow: hidden;
  background-position: top center;
  background-size: cover;
}
.contactform .label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  padding-bottom: 5px;
}
.contactform input,
.contactform textarea,
.contactform select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  max-width: 500px;
  color: white;
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: 100;
}
.contactform button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  margin-bottom: 10px;
}
.form-section input,
.form-section textarea,
.form-section select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 100;
}
.form-section button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-error {
  color: red;
  padding: 10px;
}
.form-50 {
  width: 50%;
  padding: 10px;
  float: left;
}
.form-100 {
  width: 100%;
  padding: 10px;
  float: left;
}
h2.FormTitle {
  background-color: var(--primary);
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  padding-left: 30px;
  clear: both;
  margin-top: 20px;
}
h3.FormTitle {
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  clear: both;
  margin-left: -10px;
  margin-top: 20px;
}
.form-section {
  clear: both;
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: auto;
}

.optionbox input ~ label {
  border: 1px solid var(--secondary);
  display: block;
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 100%;
}
.optionbox input:checked ~ label {
  border: 1px solid green;
  display: block;
}

.optionbox [type="checkbox"],
[type="radio"] {
  display: none;
}
.optionbox .formulate-input-group-item {
  width: 25%;
  padding: 4px;
  float: left;
}
.optionbox .formulate-input-label {
  text-align: left;
  float: left;
  margin-left: 8px;
}
.optionbox input:checked ~ label::after {
  content: " ";
  display: block;
  position: relative;
  background-color: green;
  border-radius: 10px;
  height: 10px;
  width: 10px;
  margin-left: 4px;
  margin-top: 4px;
}
@media only screen and (max-width: 660px) {
  .form-50 {
    width: 100%;
  }
  .form-50 button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contest.vue